import React from "react";
import { Checkbox, Tooltip } from "antd";
import IconFont from "@/components/icon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";
import tip from '@/assets/img/login/tip.png'
import "../../../indexNew.less"

function AutoLoginCheckbox(props: any) {
  const { appRuntimeEnv, service, focusSDK } = React.useContext<GlobalContextConfig>(GlobalContext);
  const { t } = useTranslation("common");
  const { autoLogin, qrcodeStatus, STATUS, onAutoLoginChange, loginType } = props;
  return (
    // <span style={{ display: "flex", alignItems: "center" }}>
    <span>
      <Checkbox
        style={{
          fontSize: 12
        }}
        checked={autoLogin}
        disabled={
          qrcodeStatus === STATUS.WAIT_CONFIRM ||
          qrcodeStatus === STATUS.REDIRECT ||
          qrcodeStatus === STATUS.WAIT_REDIRECT
        }
        onChange={(e: any) => {
          focusSDK.printLog("是否选中了30天登录", e.target.checked, JSON.stringify(e.target));
          onAutoLoginChange(e.target.checked);
        }}
      >
        {t("login.autoLoginPl")}
      </Checkbox>
      <Tooltip
        placement={loginType === "CA" ? "bottom" : "topRight"}
        overlayClassName="loginDescript"
        title="勾选之后，30天之内每次启动应用时不需要重新登录，退出登录之后失效。"
      >
        <img src={tip} style={{width: "16px", marginLeft: "-3px"}}/>
      </Tooltip>
    </span>
  );
}

export default AutoLoginCheckbox;
